import React from "react";
import styled from "styled-components";
import Tech from "../components/UnityGame/Unitycontext";
import Header2 from "../menu/header2";
import Accordion from '../components/accordion'
import { Link } from "@reach/router";

const PageContainer = styled.div`
  min-height: 100vh;
  padding: 5em 2em;
  background: linear-gradient(135deg, #black, #white);
  display: flex;
  flex-direction: column;
  align-items: center;
  color: white;

  @media (max-width: 768px) {
    padding: 3em 1em;
  }
`;

const Header = styled.h1`
  font-size: 2.5rem;
  font-weight: bold;
  margin-bottom: 1.5em;
  text-align: center;

  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

const ContentWrapper = styled.div`
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
`;

const GamePage = () => {
  return (
   
    <PageContainer>
      <Header2/>
      <ContentWrapper>
  
        <Accordion/>
        <Tech />
      </ContentWrapper>
    </PageContainer>
  );
};

export default GamePage;
